import styled, { css } from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  padding-top: 5.5rem;
  padding-bottom: 9.3125rem;
  width: 100vw;
  min-height: 100vh;
  background: var(--cinza-20);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: calc(100% - 48px);
  max-width: 80rem;
  padding: 3.5rem 0 2rem;

  h1 {
    font-size: 2.5rem;
    line-height: 3rem;
    font-weight: 700;
    color: var(--cinza-100);
  }

  p {
    max-width: 40rem;
    font-size: 1rem;
    line-height: 1.625rem;
    color: var(--cinza-80);
  }

  @media screen and (max-width: 950px) {
    width: 100%;
    padding: 20px 16px 24px;

    h1 {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

export const Corpo = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: calc(100% - 48px);
  max-width: 80rem;
  margin: 0 auto;

  @media screen and (max-width: 950px) {
    width: 100%;
    padding: 0 16px;
  }
`;

export const Pilulas = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;

  span {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    border-radius: 999px;
    padding: 0.5rem 0.875rem;
    font-size: 0.875rem;
    font-weight: 700;
    border: 1px solid var(--cinza-30);
    background: var(--white);
    color: var(--cinza-90);
  }

  i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: block;
  }
`;

export const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 340px), 1fr));
  gap: 1.5rem;
  align-items: start;
`;

export const Card = styled.article`
  background: var(--white);
  border: 1px solid var(--cinza-30);
  border-radius: 16px;
  box-shadow: var(--shadow-baixo-pequena);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
`;

export const CardTopo = styled.div`
  padding: 1.25rem 1.25rem 1rem;
  border-bottom: 1px solid var(--cinza-30);
  display: flex;
  flex-direction: column;
  gap: 4px;

  .eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    color: var(--cinza-70);
    text-transform: uppercase;
  }

  h2 {
    font-size: var(--font-19);
    font-weight: 900;
    color: var(--cinza-100);
    line-height: 1.3;
  }

  .sub {
    font-size: 13px;
    color: var(--cinza-70);
  }

  .pt {
    align-self: flex-start;
    margin-top: 8px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--cinza-30);
    border-radius: 8px;
    padding: 6px 10px;
    min-height: 32px;
    font: 600 12px monospace;
    color: var(--cinza-100);
    background: var(--white);
    cursor: pointer;

    svg {
      font-size: 14px;
      color: var(--cinza-80);
    }
  }
`;

export const CardCorpo = styled.div`
  padding: 1rem 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  h3 {
    font-size: var(--font-17);
    font-weight: 900;
    color: var(--cinza-100);
  }

  .desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--cinza-80);
  }
`;

const selos = {
  cliente: css`
    background: var(--atencao-10);
    color: #7a5200;
    i { background: var(--atencao-50); }
  `,
  equipe: css`
    background: var(--principal-10);
    color: #1a6b2a;
    i { background: var(--principal-50); }
  `,
  concluida: css`
    background: var(--cinza-20);
    color: var(--cinza-90);
    i { background: var(--cinza-70); }
  `,
};

export const Selo = styled.span`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1px;

  i {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: block;
  }

  ${({ vez }) => selos[vez] || selos.equipe}
`;

export const Infos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;

  div {
    background: var(--cinza-20);
    border-radius: 10px;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  small {
    font-size: 11px;
    color: var(--cinza-70);
  }

  strong {
    font-size: 14px;
    color: var(--cinza-100);
    overflow-wrap: anywhere;
  }
`;

export const Bloco = styled.div`
  border: 1px solid var(--cinza-30);
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .bloco-topo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .bloco-titulo {
    font-size: 14px;
    font-weight: 900;
    color: var(--cinza-100);
  }

  .etiqueta {
    font-size: 12px;
    font-weight: 700;
    background: var(--cinza-20);
    border: 1px solid var(--cinza-30);
    color: var(--cinza-90);
    border-radius: 6px;
    padding: 2px 8px;
    white-space: nowrap;
  }

  .etiqueta.pendente {
    background: var(--atencao-10);
    border-color: var(--atencao-20);
    color: #7a5200;
  }

  .nota {
    font-size: 12px;
    line-height: 18px;
    color: var(--cinza-70);
  }
`;

export const Dado = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  background: var(--cinza-20);
  border-radius: 8px;
  padding: 8px 8px 8px 12px;

  pre {
    margin: 0;
    font: 600 13px/20px monospace;
    color: var(--cinza-100);
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    min-width: 0;
  }
`;

export const BotaoIcone = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--cinza-40);
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  svg {
    font-size: 16px;
    color: var(--cinza-80);
  }
`;

export const Botao = styled.button`
  min-height: 44px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  font: 700 15px Lato, sans-serif;
  cursor: pointer;
  width: 100%;
  text-decoration: none;

  ${({ secundario }) =>
    secundario
      ? css`
          background: var(--white);
          color: var(--cinza-90);
          border: 1px solid var(--cinza-40);
        `
      : css`
          background: var(--neutro-30);
          color: var(--white);
          border: 1px solid var(--neutro-30);
        `}

  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }

  svg {
    font-size: 18px;
  }
`;

export const BotaoLink = styled(Botao).attrs({ as: "a" })``;

export const LinkTexto = styled.button`
  align-self: flex-start;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  padding: 0;
  font: 700 14px Lato, sans-serif;
  color: var(--neutro-40);
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: var(--principal-50);
  }

  svg {
    font-size: 18px;
  }
`;

export const ListaAux = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    background: var(--cinza-20);
    border-radius: 8px;
    padding: 10px 10px 10px 12px;
  }

  li.enviado {
    background: var(--principal-10);
  }

  strong {
    display: block;
    font-size: 14px;
    color: var(--cinza-100);
  }

  small {
    display: block;
    font-size: 12px;
    color: var(--cinza-70);
    margin-top: 2px;
    overflow-wrap: anywhere;
  }

  .ok {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 700;
    color: #1a6b2a;
    flex-shrink: 0;

    svg {
      font-size: 16px;
    }
  }

  button {
    min-height: 36px;
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid var(--cinza-40);
    background: var(--white);
    font: 700 13px Lato, sans-serif;
    color: var(--cinza-90);
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    flex-shrink: 0;

    svg {
      font-size: 16px;
    }
  }
`;

export const Andamento = styled.div`
  border: 1px solid var(--cinza-30);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 4px;

  .topo {
    display: flex;
    justify-content: space-between;
    align-items: center;

    strong {
      font-size: 14px;
      color: var(--cinza-100);
    }

    span {
      font-size: 11px;
      background: var(--cinza-20);
      border: 1px solid var(--cinza-30);
      border-radius: 6px;
      padding: 2px 8px;
      color: var(--cinza-80);
    }
  }

  ol {
    list-style: none;
  }

  li {
    display: flex;
    gap: 10px;
    position: relative;
    padding-bottom: 12px;

    &:last-child {
      padding-bottom: 0;
    }

    &::before {
      content: "";
      position: absolute;
      left: 10px;
      top: 22px;
      bottom: 0;
      width: 2px;
      background: var(--cinza-30);
    }

    &:last-child::before {
      display: none;
    }
  }

  .ponto {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    box-sizing: border-box;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    background: var(--white);
    border: 2px solid var(--cinza-40);

    svg {
      font-size: 14px;
      color: var(--white);
    }
  }

  .texto {
    display: flex;
    flex-direction: column;
    font-size: 13px;
    line-height: 18px;
    color: var(--cinza-70);
    padding-top: 2px;
  }

  li.feito::before {
    background: var(--principal-50);
  }

  li.feito .ponto {
    background: var(--principal-50);
    border-color: var(--principal-50);
  }

  li.feito .texto b {
    color: var(--cinza-100);
  }

  li.cliente .ponto {
    border-color: var(--atencao-50);
  }

  li.cliente .texto {
    color: #7a5200;
    font-weight: 700;
  }

  li.equipe .ponto {
    border-color: var(--principal-50);
    background: var(--principal-20);
  }

  li.equipe .texto {
    color: #1a6b2a;
    font-weight: 700;
  }
`;

export const Explicacao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: var(--cinza-90);
  font-size: 15px;
  line-height: 24px;

  h2 {
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 900;
    color: var(--cinza-100);
  }

  h3 {
    font-size: 1rem;
    font-weight: 900;
    color: var(--cinza-100);
    margin-top: 0.5rem;
  }

  h4 {
    font-size: 15px;
    font-weight: 700;
    color: var(--cinza-100);
  }

  ul,
  ol {
    padding-left: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .dica {
    background: var(--principal-10);
    border-radius: 8px;
    padding: 10px 12px;
  }
`;
